import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';
import { Cell, CellInner, CellIcon } from './CartToolBarCell';

const CellText = styled.div`
  flex-grow: 1;
  text-indent: calc(-0.89em - 8px);
  text-align: center;
`;

class CartToolBarToggle extends React.PureComponent {
  static propTypes = {
    toggle: PropTypes.func,
    title: PropTypes.string,
  };

  static defaultProps = {
    toggle: _.identity,
    title: '',
  };

  render() {
    const { toggle, title } = this.props;

    return (
      <Cell full onClick={toggle}>
        <CellInner full>
          <CellIcon suffix icon="times" />
          <CellText>{title}</CellText>
        </CellInner>
      </Cell>
    );
  }
}

export default CartToolBarToggle;



// WEBPACK FOOTER //
// ./src/components/Cart/CartToolBarToggle.js